/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { MdArrowBack } from "react-icons/md";
import HomeService from "../../../services/home.service";

const ViewActivity = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const item = state?.item || {};

  const [data, setData] = useState([]);
  const [loadingInitial, setLoadingInitial] = useState(true);

  useEffect(() => {
    loadActivity();
  }, []);

  const loadActivity = async () => {
    try {
      const res = await HomeService.admin.viewActivity({
        withoutLoading: true,
        package_id: item.id,
      });
      setData(res.data || []);
    } catch (error) {
      console.error(error);
      toast.error("Error al cargar la actividad");
    } finally {
      setLoadingInitial(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <div className="max-w-5xl mx-auto py-6 px-4 md:px-8">
      {/* HEADER / TITULO */}
      <div className="flex items-center gap-4 mb-6">
        <button
          onClick={() => navigate(-1)}
          className="p-2 text-gray-600 hover:text-[#1D3B8B] hover:bg-gray-100 rounded-xl transition-colors"
          title="Volver"
        >
          <MdArrowBack size={24} />
        </button>
        <div>
          <h1 className="text-xl font-bold text-gray-900 uppercase">
            {item.number || "BL Desconocido"}
          </h1>
          <p className="text-sm font-semibold text-purple-600 uppercase">
            {item.code || ""}
          </p>
        </div>
      </div>

      {/* TABLA DE ACTIVIDAD */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left text-gray-600">
            <thead className="text-xs text-gray-500 uppercase bg-gray-50/80 border-b border-gray-100">
              <tr>
                <th className="px-6 py-4 font-semibold w-1/4">Fecha</th>
                <th className="px-6 py-4 font-semibold w-1/2">
                  Última Actividad
                </th>
                <th className="px-6 py-4 font-semibold w-1/4">Ubicación</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {loadingInitial && data.length === 0 && (
                <tr>
                  <td
                    colSpan="3"
                    className="px-6 py-8 text-center text-[#1D3B8B] font-medium"
                  >
                    Cargando...
                  </td>
                </tr>
              )}

              {!loadingInitial && data.length === 0 && (
                <tr>
                  <td
                    colSpan="3"
                    className="px-6 py-8 text-center text-gray-400"
                  >
                    No se han encontrado registros
                  </td>
                </tr>
              )}

              {data.map((row, index) => (
                <tr
                  key={row.id || index}
                  className="hover:bg-gray-50/50 transition-colors"
                >
                  <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                    {formatDate(row.date)}
                  </td>
                  <td className="px-6 py-4 text-gray-800">
                    {row.last_activity || "-"}
                  </td>
                  <td className="px-6 py-4 text-gray-600">
                    {row.location || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ViewActivity;
